/* Shared, dependency-free carousel used by the hero, featured rail, and product
   gallery. Each carousel is configured entirely via data attributes so theme
   sections can wire autoplay/speed from their {% schema %} settings without any
   bundler step.

   Markup contract:
     <div class="js-carousel"
          data-autoplay="true"
          data-speed="6000"
          data-loop="true">
       <div data-carousel-track>
         <div data-carousel-slide>...</div>
         ...
       </div>
       <button data-carousel-prev></button>
       <button data-carousel-next></button>
       <div data-carousel-dots></div>
     </div>

   Two visual modes:
     - "fade" (default): slides stacked, cross-fade between them (hero).
     - "slide": horizontal translate of the track (product gallery).
   Set data-mode="slide" for the translate mode. */

(function () {
  function initCarousel(root) {
    if (root.dataset.carouselReady === "true") return;
    root.dataset.carouselReady = "true";

    var track = root.querySelector("[data-carousel-track]");
    if (!track) return;
    var slides = Array.prototype.slice.call(
      track.querySelectorAll("[data-carousel-slide]")
    );
    if (slides.length === 0) return;

    var mode = root.dataset.mode === "slide" ? "slide" : "fade";
    var loop = root.dataset.loop !== "false";
    var autoplay = root.dataset.autoplay === "true" && slides.length > 1;
    var speed = parseInt(root.dataset.speed, 10) || 6000;

    if (mode === "slide") {
      track.style.transition = "transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)";
    }

    var prevBtn = root.querySelector("[data-carousel-prev]");
    var nextBtn = root.querySelector("[data-carousel-next]");
    var dotsWrap = root.querySelector("[data-carousel-dots]");

    var index = 0;
    var timer = null;

    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = "";
      if (slides.length > 1) {
        slides.forEach(function (_, i) {
          var dot = document.createElement("button");
          dot.type = "button";
          dot.className = dotsWrap.dataset.dotClass || "carousel-dot";
          dot.setAttribute("aria-label", "Go to slide " + (i + 1));
          dot.addEventListener("click", function () {
            goTo(i);
            restart();
          });
          dotsWrap.appendChild(dot);
          dots.push(dot);
        });
      }
    }

    function render() {
      slides.forEach(function (slide, i) {
        var active = i === index;
        if (mode === "fade") {
          slide.classList.toggle("is-active", active);
          slide.setAttribute("aria-hidden", active ? "false" : "true");
        }
      });
      if (mode === "slide") {
        var offset = slides[index].offsetLeft - slides[0].offsetLeft;
        track.style.transform = "translateX(" + -offset + "px)";
      }
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === index);
        if (i === index) dot.setAttribute("aria-current", "true");
        else dot.removeAttribute("aria-current");
      });
    }

    function goTo(i) {
      if (loop) {
        index = (i + slides.length) % slides.length;
      } else {
        index = Math.max(0, Math.min(i, slides.length - 1));
      }
      render();
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    function start() {
      if (!autoplay) return;
      if (
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ) {
        return;
      }
      stop();
      timer = setInterval(next, speed);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    if (nextBtn) nextBtn.addEventListener("click", function () { next(); restart(); });
    if (prevBtn) prevBtn.addEventListener("click", function () { prev(); restart(); });

    var showControls = slides.length > 1;
    [prevBtn, nextBtn].forEach(function (btn) {
      if (btn) btn.style.display = showControls ? "" : "none";
    });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);

    if (mode === "slide") {
      var resizeTimer = null;
      window.addEventListener("resize", function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          // Re-measure without animating to the new offsets.
          var prevTransition = track.style.transition;
          track.style.transition = "none";
          render();
          // Force reflow then restore the transition.
          void track.offsetWidth;
          track.style.transition = prevTransition;
        }, 150);
      });
    }

    // Touch / swipe support.
    var startX = 0;
    var dragging = false;
    track.addEventListener("touchstart", function (e) {
      startX = e.touches[0].clientX;
      dragging = true;
      stop();
    }, { passive: true });
    track.addEventListener("touchend", function (e) {
      if (!dragging) return;
      dragging = false;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) {
        if (dx < 0) next();
        else prev();
      }
      start();
    });

    render();
    start();
  }

  function initAll() {
    document.querySelectorAll(".js-carousel").forEach(initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Re-init when sections are added/edited in the Theme Editor.
  document.addEventListener("shopify:section:load", initAll);

  window.ChefRancherCarousel = { init: initCarousel, initAll: initAll };
})();
